<div
  *ngIf="!altFormat"
  class="text-palette-m3-system-gray-35 uppercase dls-caption-regular"
>
  {{ translations.location }}
  <span *ngIf="location.future_effective_date && translations.effectiveAlert">
    <mat-icon
      svgIcon="dls-exclamation-circle-light"
      class="text-palette-m3-system-red-40 h-6 w-6 align-bottom"
      data-cy="location-effective-alert-exclamation-icon"
      [inline]="true"
      [matTooltip]="translations.effectiveAlert"
    >
    </mat-icon>
  </span>
  <span
    *ngIf="location.future_termination_date && translations.terminationAlert"
  >
    <mat-icon
      svgIcon="dls-exclamation-circle-light"
      class="text-palette-m3-system-red-40 h-6 w-6 align-bottom"
      data-cy="location-termination-alert-exclamation-icon"
      [inline]="true"
      [matTooltip]="translations.terminationAlert"
    >
    </mat-icon>
  </span>
</div>
<div class="text-sm">
  <ng-container *ngIf="!altFormat; else altAddress">
    <div
      *ngIf="location.location_name"
      data-cy="location-name"
      [zelisHighlight]="searchTerm || ''"
      [innerHTML]="location.location_name"
      [ngClass]="{ 'ml-8': showIcon }"
    ></div>
    <div
      *ngIf="medGroupEnabled && location.group_affiliations?.length"
      data-cy="location-group-affiliations"
    >
      <div
        *ngFor="let group of location.group_affiliations; trackBy: trackByFn"
      >
        {{ group.name }}
        <span *ngIf="group.information">
          ({{ translations.medical_group_number }} {{ group.information }})
        </span>
      </div>
    </div>
    <div
      data-cy="location-address"
      [ngClass]="{ 'flex items-center': showIcon }"
    >
      <span *ngIf="showIcon" class="flex items-center mr-2">
        <mat-icon svgIcon="dls-map-marker-dot-light"></mat-icon>
      </span>
      <span
        *ngIf="location.addr_line1"
        [zelisHighlight]="searchTerm || ''"
        [innerHTML]="location.addr_line1"
      ></span>
      <span *ngIf="location.addr_line1">, </span>
      <span
        *ngIf="location.addr_line2"
        [zelisHighlight]="searchTerm || ''"
        [innerHTML]="location.addr_line2"
      ></span>
      <span *ngIf="location.addr_line2">, </span>
      <span *ngIf="location.city && location.state && location.postal_code">
        {{ location.city }}, {{ location.state }} {{ location.postal_code }}
      </span>
    </div>
  </ng-container>
  <ng-template #altAddress>
    <div class="location-address altFormat">
      <h5 *ngIf="location.addr_line1" [innerHTML]="location.addr_line1"></h5>
      <h5>
        <span *ngIf="location.city" [innerHTML]="location.city"></span>
        <span *ngIf="location.city && (location.state || location.postal_code)"
          >,
        </span>
        {{ location.state }} {{ location.postal_code }}
      </h5>
    </div>
  </ng-template>
  <div class="location-address-map-link" *ngIf="getDirectionsAction">
    <a
      href=""
      (click)="getDirections($event)"
      tabindex="0"
      data-cy="location-address-map-link"
    >
      <span *ngIf="location.addr_line1">{{ location.addr_line1 }}, </span>
      <span *ngIf="location.addr_line2">{{ location.addr_line2 }}, </span>
      <span *ngIf="location.city && location.state && location.postal_code">
        {{ location.city }}, {{ location.state }} {{ location.postal_code }}
      </span>
    </a>
  </div>
  <div class="get-directions-container" [ngClass]="{ 'ml-8': showIcon }">
    <a
      *ngIf="getDirectionsAction && showDirections"
      href=""
      role="link"
      class="underline"
      (click)="getDirections($event)"
      tabindex="0"
      data-cy="location-map-link"
      >{{ translations.map }}</a
    >
    <span *ngIf="showDistance && location.distance" data-cy="location-distance">
      ({{ translations.est }} {{ location.distance | number: '1.1-1' }}
      {{ distanceTranslation(location.distance | number: '1.1-1') }})
    </span>
  </div>
</div>
